import { plans } from "@/config/stripePlans";
import { validTrialDays } from "./trials";
import type { OnboardingData } from "./types";

// Staff don't wait for the client to set a password: the setup email going out is
// enough to keep going.
export function validateAccount(d: OnboardingData): boolean {
  return d.accountCreated || d.inviteSent;
}

export function validateBusiness(d: OnboardingData): boolean {
  return (
    d.businessName.trim().length > 0 &&
    d.contactName.trim().length > 0 &&
    d.phone.trim().length > 0 &&
    d.category.trim().length > 0
  );
}

export function validatePlan(d: OnboardingData): boolean {
  if (!plans[d.selectedPlan]) return false;
  // Early Supporter requires picking at least one comped grant.
  if (d.selectedPlan === "early_supporter") {
    return d.earlySupporterGrants.length > 0;
  }
  if (d.startMode === "trial") {
    return d.trialNeverExpires || validTrialDays(d.trialDays);
  }
  return true;
}

export function canProceedFromStep(step: number, d: OnboardingData): boolean {
  switch (step) {
    case 0:
      return validateAccount(d);
    case 1:
      return validateBusiness(d);
    case 2:
      return validatePlan(d);
    default:
      // Review and Finish auto-pass.
      return true;
  }
}
